import React, { Component } from "react";
//import styled, { keyframes } from 'styled components';
import PropTypes from 'prop-types';


import gelFlat from "../../img/agarose-gel-side-view.svg";
// import gelFlipped from "../../img/agarose-gel-5-front-view.svg";
import gelFlipped from "../../img/gel8.svg";

const images = {
  gelFlipped: gelFlipped,
  gelFlat: gelFlat
};

export class Graphics extends Component {
  componentWillMount() {
    for (var image in images) {
      if (!image.replace(this.props.type, "").includes(0)) {
        const img = new Image();
        img.src = images[image];
      }
    }
  }

  getImage = () => {
    let reference = "gel";

    if (this.props.held) {
      reference += "Flipped";
    } else if (!this.props.onShelf){
      reference += "Flipped";
    } else if(this.props.materialsView){
      reference += "Flipped";
    } else {
      reference += "Flipped";
    }

    return images[reference];
  };

  render (){
    return(
      <img
      width="100"
      aria-label="Agarose Gel"
      alt="Agarose Gel"
      aria-hidden={this.props.context==="Materials"?"true":"false"}
      className={this.props.type+"-gel gel"}
      src={this.getImage()}/>
    )
  }
}
Graphics.propTypes = {
  setGelHeld: PropTypes.func,
}

Graphics.defaultProps = {

}

// const mapStateToProps = (state, ownProps) => {
//   return {
//     id: ownProps.id,
//     aria: ownProps.aria,
//     type: state.notebook.protocolSection.scene.apparatus.AgaroseGels[ownProps.id - 1].type,
//     // orientation: ownProps.orientation,
//     onShelf: state.notebook.protocolSection.scene.apparatus.AgaroseGels[ownProps.id - 1].onShelf,
//     held: state.notebook.protocolSection.scene.apparatus.AgaroseGels[ownProps.id - 1].held,
//     materialsView: ownProps.materialsView,
//   };
// };

// export default connect(
//   mapStateToProps,
//   {}
// )(Graphics);
